<div
    class="alert-container alert alert-dismissible dark-shadow-sm"
    role="alert"
    [ngClass]="'alert-' + alert.severity"
>
    <div class="d-flex">
        <div
            class="mr-2 alert-header"
            *ngIf="alert.header"
            [innerHtml]="alert.header"
        ></div>
        <div>
            <ul id="ul"></ul>
        </div>
    </div>
    <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeAlert(alert)"
    >
        <span aria-hidden="true">&times;</span>
    </button>
</div>
